import {Directive, ElementRef, HostBinding, Input} from '@angular/core';

const headerOffset = 130;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[popinAnchor]'
})
export class PopinAnchorDirective {

  _isActive = false;
  @Input() id: string;

  @HostBinding('id') get idAttribute(): string {
    return this.id;
  }

  @Input() titre: string;

  set isActive(value: boolean) {
    this._isActive = value;
  }

  get isActive() {
    return this._isActive;
  }

  constructor(private element: ElementRef) {
  }


  get isBottomLowerThanTopClientScreen(): boolean {
    const boudingClientRect = this.element.nativeElement.getBoundingClientRect();
    return boudingClientRect.bottom > headerOffset;
  }


}
